import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Navbar, Nav, Form, FormControl, Button } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { useSite } from '../context/SiteContext';
import { getMediaUrl } from '../services/api';
import api from '../services/api';
import './Header.css';

const Header = () => {
  const { config } = useSite();
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    loadMenus();
  }, []);

  const loadMenus = async () => {
    try {
      const response = await api.get('/menus/', { params: { location: 'header' } });
      setMenus(response.data);
    } catch (error) {
      console.error('Error loading menus:', error);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
      setSearchQuery('');
      setExpanded(false);
    }
  };

  const renderMenuItem = (item) => {
    if (item.children && item.children.length > 0) {
      return (
        <li key={item.id} className="nav-item dropdown">
          <a className="nav-link dropdown-toggle btn btn-link" href="#" role="button" data-bs-toggle="dropdown">
            {item.label}
          </a>
          <ul className="dropdown-menu">
            {item.children.map(child => (
              <li key={child.id}>
                <Link className="dropdown-item" to={child.url} onClick={() => setExpanded(false)}>
                  {child.label}
                </Link>
              </li>
            ))}
          </ul>
        </li>
      );
    }
    
    return (
      <li key={item.id} className="nav-item">
        <Link className="nav-link" to={item.url} onClick={() => setExpanded(false)}>
          {item.label}
        </Link>
      </li>
    );
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <Container>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="site-identity">
              {config?.logo && (
                <img 
                  src={getMediaUrl(config.logo)} 
                  alt={config.site_name} 
                  className="site-logo"
                />
              )}
              <div className="site-info">
                <h1 className="site-name">{config?.site_name}</h1>
                <p className="site-tagline">{config?.site_tagline}</p>
              </div>
            </div>
            
            <div className="header-search">
              <Form className="d-flex" onSubmit={handleSearch}>
                <FormControl
                  type="search"
                  placeholder="Search..."
                  className="me-2"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  aria-label="Search"
                />
                <Button variant="primary" type="submit">
                  <FaSearch />
                </Button>
              </Form>
            </div>
          </div>
        </Container>
      </div>
      
      <Navbar bg="primary" variant="dark" expand="lg" className="main-navigation" expanded={expanded}>
        <Container>
          <Navbar.Toggle 
            aria-controls="main-navbar" 
            onClick={() => setExpanded(!expanded)}
          />
          <Navbar.Collapse id="main-navbar">
            <Nav as="ul" className="navbar-nav">
              {menus.map(menu => menu.items.map(item => renderMenuItem(item)))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
